import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicLabel from '../BasicLabel';
import BasicSelect from '../BasicSelect';

const DateSelect = props => {
  const {
    isValid = true,
    isLast = false,
    label,
    labelStyles,
    required,
    controlFunc,
    yearOptions,
    monthOptions: propsMonthOptions = null,
    showMonthLikeNumber = false,
    touchFunc,
    name,
    values,
  } = props;

  const monthOptions = useMemo(() => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ].map((month, index) => ({
      value: index + 1,
      label: showMonthLikeNumber
        ? index > 8
          ? index + 1
          : '0' + (index + 1)
        : month,
    }));

    return propsMonthOptions
      ? months.filter(
          (month, index) => propsMonthOptions.indexOf(index + 1) !== -1
        )
      : months;
  }, [propsMonthOptions]);

  const monthSelectedOption = useMemo(() => {
    const month = values && values.month ? Number(values.month) : null;
    if (!month || month < 1 || month > 12) {
      return null;
    }
    const result = monthOptions.filter(m => m.value === month);
    return result.length ? result[0] : null;
  }, [values]);

  const yearSelectedOption = useMemo(
    () =>
      values && values.year
        ? {
            value: Number(values.year),
            label: values.year,
          }
        : null,
    [values]
  );

  const selectOnChangeMonth = ({ value }) => {
    controlFunc(name, {
      month: value,
      year: yearSelectedOption ? yearSelectedOption.value : null,
    });
  };

  const selectOnChangeYear = ({ value }) => {
    controlFunc(name, {
      month: monthSelectedOption ? monthSelectedOption.value : null,
      year: value,
    });
  };

  const handleOnBlur = () => {
    if (touchFunc) {
      touchFunc(name, true, true);
    }
  };

  return (
    <div className="date-select">
      {label && (
        <BasicLabel
          name={name}
          required={required}
          text={label}
          styles={labelStyles || { fontWeight: 'bold', fontSize: '0.9286rem' }}
        />
      )}
      <div className="date-select__row">
        <div className="date-select__element">
          <BasicSelect
            isSearchable={false}
            name={`${name}_month`}
            value={monthSelectedOption}
            isValid={isValid}
            placeholder="Month"
            options={monthOptions}
            controlFunc={selectOnChangeMonth}
            touchFunc={handleOnBlur}
            isLast={isLast}
          />
        </div>

        <div className="date-select__element">
          <BasicSelect
            isSearchable={false}
            name={`${name}_year`}
            value={yearSelectedOption}
            isValid={isValid}
            placeholder="Year"
            options={yearOptions}
            controlFunc={selectOnChangeYear}
            touchFunc={handleOnBlur}
            isLast={isLast}
          />
        </div>
      </div>
    </div>
  );
};

DateSelect.propTypes = {
  label: PropTypes.string,
  labelStyles: PropTypes.object,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
  yearOptions: PropTypes.array,
  monthOptions: PropTypes.array,
  showMonthLikeNumber: PropTypes.bool,
  values: PropTypes.shape({
    month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  controlFunc: PropTypes.func.isRequired,
  touchFunc: PropTypes.func,
  isLast: PropTypes.bool,
};

export default DateSelect;
